import {
  GET_FB_STATUS_LOG,
  FB_STATUS_LOG_ERROR,
  GET_FB_ALERT,
} from "../../types";

const StatusLogReducer = (state, action) => {
  switch (action.type) {
    case GET_FB_STATUS_LOG:
      return { ...state, status_logs: action.payload };

    case GET_FB_ALERT:
      return { ...state, facebook_alerts: action.payload };

    case FB_STATUS_LOG_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default StatusLogReducer;